import React from 'react';
import { Outlet, Route, Routes } from 'react-router';
import App from 'views/App';
import Resumo from 'views/Resumo';
import Configurações from 'views/Configurações';
import Ordens from 'views/Ordens';
import OrdensGerar from 'views/Ordens/Gerar';
import OrdensProdução from 'views/Ordens/Produção';
import OrdensEtiquetas from 'views/Ordens/Etiquetas';
import OrdensMateriais from 'views/Ordens/Materiais';
import OrdensApontamento from 'views/Ordens/Apontamento';
import OrdensNecessidade from 'views/Ordens/Necessidade';
import OrdensRejeição from 'views/Ordens/Rejeição';
import Recursos from 'views/Recursos';
import Mapa from 'views/Mapa';
import Documento from 'views/Documento';
import DocumentoItem from 'views/Documento/Item';
import DocumentoQualidade from 'views/Documento/Qualidade';
import DocumentoAprovações from 'views/Documento/Aprovações';
//RELATÓRIOS
import Relatórios from 'views/Relatórios';
import RelatóriosFiltros from 'views/Relatórios/Filtros';
//OUTLETS
import OutletDocumento from './Outlets/Documento';

const RoutesTree = () => (
  <Routes>
    <Route path="" element={<App />} />
    <Route path="Resumo" element={<Resumo />} />
    <Route path="Configuracoes" element={<Configurações />} />
    <Route path="Recursos" element={<Recursos />} />
    <Route path="Mapa" element={<Mapa />} />
    <Route path="Ordens" element={<Outlet />}>
      <Route path="" element={<Ordens />} />
      <Route path="Gerar" element={<OrdensGerar />} />
      <Route path="Etiquetas" element={<OrdensEtiquetas />} />
      <Route path="Necessidade" element={<OrdensNecessidade />} />
      <Route path="Producao/:hash" element={<OrdensProdução />} />
      <Route path="Materiais/:hash" element={<OrdensMateriais />} />
      <Route path="Apontamento/:hash?" element={<OrdensApontamento />} />
      <Route path="Rejeicao/:id?" element={<OrdensRejeição />} />
    </Route>
    <Route path="Documento" element={<OutletDocumento />}>
      <Route path=":id" element={<Documento />} />
      <Route path="Item" element={<DocumentoItem />} />
      <Route path="Qualidade/:hash" element={<DocumentoQualidade />} />
      <Route path="Aprovacoes" element={<DocumentoAprovações />} />
    </Route>
    <Route path="Relatorios" element={<Outlet />}>
      <Route path="" element={<Relatórios />} />
      <Route path="Filtros" element={<RelatóriosFiltros />} />
    </Route>
  </Routes>
);

export default RoutesTree;
